var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWallet01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24366 1.79379C9.53391 1.6072 9.91856 1.67292 10.1304 1.94528L12.1702 4.56791H13.1242C13.8458 4.56791 14.4308 5.15292 14.4308 5.87458V7.44843C14.7867 7.46243 15.0708 7.75532 15.0708 8.11458V11.6346C15.0708 11.9938 14.7867 12.2867 14.4308 12.3007V14.1946C14.4308 14.9162 13.8458 15.5012 13.1242 15.5012H2.24417C1.52251 15.5012 0.9375 14.9162 0.9375 14.1946V5.87458C0.9375 5.15292 1.52251 4.56791 2.24417 4.56791H4.92836L9.24366 1.79379ZM5.11438 5.90124C5.12132 5.90135 5.12826 5.90135 5.1352 5.90124H11.8382C11.8425 5.90128 11.8468 5.90128 11.851 5.90124H13.0975V7.44791H12.3242C10.984 7.44791 9.8975 8.53437 9.8975 9.87458C9.8975 11.2148 10.984 12.3012 12.3242 12.3012H13.0975V14.1679H2.27083V5.90124H5.11438ZM10.4811 4.56791H7.39404L9.45206 3.24489L10.4811 4.56791ZM12.3242 8.78124C11.7203 8.78124 11.2308 9.27075 11.2308 9.87458C11.2308 10.4784 11.7203 10.9679 12.3242 10.9679H13.7375V8.78124H12.3242Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWallet01);
export default __webpack_public_path__ + "static/media/ic-wallet-01.ce17f4631d2fb7d4979d1fa355cc475a.svg";
export { ForwardRef as ReactComponent };